interface i18n {
    defaultLocale: string;
    locales: string[];
}


export const i18n: i18n = {
    defaultLocale: "kz",
    locales: ["ru", "kz"],
} as const;

export type Locale = (typeof i18n)["locales"][number];